// Mascote global que reage a acertos/erros/win. Persiste um elemento no body
// e atualiza emoji + classes conforme eventos. Pra desligar, basta não chamar.

type Reaction = 'correct' | 'wrong' | 'win';

const EMOJI: Record<Reaction, string> = {
  correct: '🎉',
  wrong: '😔',
  win: '🦁',
};

class MascotManagerImpl {
  private el: HTMLElement | null = null;
  private hideTimer: number | null = null;
  private enabled = true;
  private modoAdulto = false; // F2: adulto não ganha 🎉/😔/🦁 (gate separado da pref do usuário)

  setEnabled(value: boolean): void {
    this.enabled = value;
    if (!value) this.hide();
  }

  setModoAdulto(value: boolean): void {
    this.modoAdulto = value;
    if (value) this.hide();
  }

  private ensureEl(): HTMLElement {
    if (this.el && document.body.contains(this.el)) return this.el;
    const el = document.createElement('div');
    el.className = 'mascot';
    el.setAttribute('aria-hidden', 'true');
    document.body.appendChild(el);
    this.el = el;
    return el;
  }

  react(kind: Reaction): void {
    if (!this.enabled || this.modoAdulto) return;
    const el = this.ensureEl();
    el.textContent = EMOJI[kind];
    el.classList.remove('mascot--celebrate');
    // forçar reflow pra reiniciar a animação
    void el.offsetWidth;
    el.classList.add('mascot--show');
    if (kind === 'win') el.classList.add('mascot--celebrate');
    if (this.hideTimer !== null) window.clearTimeout(this.hideTimer);
    const duration = kind === 'win' ? 2800 : 2000;
    this.hideTimer = window.setTimeout(() => this.hide(), duration);
  }

  private hide(): void {
    if (!this.el) return;
    this.el.classList.remove('mascot--show', 'mascot--celebrate');
    if (this.hideTimer !== null) {
      window.clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }
}

export const mascotManager = new MascotManagerImpl();
